/**
 * 路径
 * */
const bt = 'bt'
const auth = 'auth'
/**
 *
 * 网关模块
 *
 * */
export const getaway = {
  user: '/user/',
  business: '/business/',
  roles: ''
}

/**
 * 请求路径
 * */
export const baseURL = {
  authApi: getaway.user + auth,
  userApi: getaway.user + bt,
  businessApi: getaway.business + bt,
  businessRoles: getaway.roles + bt,
}
